/* OS Location Message - personalized shipping message with visitor geolocation (scoped, no globals) */
(() => {
  const CACHE_KEY = 'os-location-message-geo';
  const CACHE_TTL = 24 * 60 * 60 * 1000; // 24h — one ipwho.is lookup per visitor per day, shared across tabs
  const ANIMATION_MS = 2400;

  let pendingFetch = null;

  function getCachedLocation() {
    try {
      const raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      const data = JSON.parse(raw);
      if (!data || Date.now() - data.ts > CACHE_TTL) return null;
      return data.location;
    } catch (e) {
      return null;
    }
  }

  function setCachedLocation(location) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), location }));
    } catch (e) {}
  }

  function formatDeliveryDate(days) {
    const d = new Date();
    d.setDate(d.getDate() + parseInt(days, 10));
    return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
  }

  function formatLocation(data, type) {
    if (!data) return null;
    switch (type) {
      case 'country':
        return data.country;
      case 'region':
        return data.region || data.region_code;
      case 'city_region': {
        const city = data.city;
        const region = data.region || data.region_code;
        if (city && region) return `${city}, ${region}`;
        return city || region || data.country;
      }
      case 'city':
      default:
        return data.city || data.region || data.country;
    }
  }

  function fetchVisitorLocation() {
    return fetch('https://ipwho.is/')
      .then((res) => res.json())
      .then((data) => {
        if (!data || data.success === false) throw new Error('geo lookup failed');
        return {
          city: data.city,
          region: data.region,
          region_code: data.region_code,
          country: data.country,
        };
      })
      .catch(() => {
        const rootPath = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
        const endpoint = (rootPath + 'browsing_context_suggestions.json').replace(/\/+/g, '/');

        return fetch(endpoint)
          .then((res) => res.json())
          .then((data) => {
            const countryName = data && data.detected_values && data.detected_values.country && data.detected_values.country.name;
            if (!countryName) throw new Error('Shopify fallback failed');
            return { country: countryName };
          });
      });
  }

  function applyDeliveryDates() {
    document.querySelectorAll('[data-location-date]').forEach((el) => {
      const days = el.getAttribute('data-location-date');
      if (days) el.textContent = formatDeliveryDate(days);
    });
  }

  function applyLocations(locationData) {
    document.querySelectorAll('[data-location-type]').forEach((el) => {
      const type = el.getAttribute('data-location-type') || 'city';
      const fallback = el.getAttribute('data-location-fallback');
      const placeEl = el.querySelector('[data-location-place]');
      if (!placeEl) return;

      const formatted = formatLocation(locationData, type) || fallback;
      if (formatted) placeEl.textContent = formatted;
    });
  }

  function playAnimations() {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-location-anim]').forEach((el) => {
      el.classList.remove('is-animating', 'is-complete');

      if (reducedMotion) {
        el.classList.add('is-complete');
        return;
      }

      void el.offsetWidth;
      el.classList.add('is-animating');

      window.setTimeout(() => {
        el.classList.remove('is-animating');
        el.classList.add('is-complete');
      }, ANIMATION_MS);
    });
  }

  function init() {
    if (!document.querySelector('[data-location-type]')) return;

    applyDeliveryDates();
    playAnimations();

    const cached = getCachedLocation();
    if (cached) {
      applyLocations(cached);
      return;
    }

    if (!pendingFetch) {
      pendingFetch = fetchVisitorLocation()
        .then((locationData) => {
          setCachedLocation(locationData);
          return locationData;
        })
        .catch((err) => {
          console.warn('Location message: all geolocation routes failed', err);
          return null;
        })
        .finally(() => {
          pendingFetch = null;
        });
    }

    pendingFetch.then((locationData) => {
      if (locationData) applyLocations(locationData);
    });
  }

  window.osLocationMessage = { init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
